import { locales } from '@americanexpress/conditional-features';

const {
  EN_CA,
  FR_CA,
  EN_US,
} = locales;

export const hasDisableTravelerTooltipRule = [EN_CA, FR_CA];
export const hasAnalyticsRule = [EN_US];
